import { Directive, HostListener, Input } from '@angular/core';
import { XcoScrollToService } from '../services/xco-scroll-to.service';

@Directive({
  selector: '[appXcoScrollto]',
  providers: [XcoScrollToService]
})
export class XcoScrolltoDirective {
  @Input() xcoScrollto: any;
  @Input() xcoScrolltoFixed: any;
  @Input() xcoScrolltoDuration: number;

  constructor(private scrollToService: XcoScrollToService) {}

  @HostListener('click', ['$event']) onClick($event) {
    $event.preventDefault();
    this.scrollToService.scrollTo(
      document.querySelector(this.xcoScrollto),
      this.xcoScrolltoFixed,
      this.xcoScrolltoDuration
    );
  }

}
